export default __webpack_public_path__ + "images/G5.380fcf2.png";